import styled from "styled-components";

export default styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;

  .send-image-modal-cont {
    &--close {
      transition: opacity 0.3s ease-in-out;
      opacity: 0;
    }
  }

  .send-image-modal {
    position: relative;
    width: 80vw;
    height: 90vh;
    max-width: 570px;
    max-height: 600px;
    background-color: black;
    border-radius: 12px;

    .img-container {
      position: absolute;
      height: 100%;
      width: 100%;
      background-color: black;
      border-radius: 12px;

      .image-reference {
        position: relative;
        width: 100%;
        height: 100%;

        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 12px;

        &--horizontal {
          .image-container {
            height: auto;
            width: 100%;
            object-fit: contain;
          }
        }

        &--vertical {
          .image-container {
            height: 100%;
            width: auto;
            object-fit: contain;
          }
        }
      }
    }

    .actions {
      position: absolute;
      bottom: 0;
      width: 100%;

      background-color: rgba(0, 0, 0, 0.5);
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom-left-radius: 12px;
      border-bottom-right-radius: 12px;
      padding: 0.75rem 1rem;

      .send-icon-cont {
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 100%;
        padding: 0.5rem;

        background-color: #0ba6ff;
        cursor: pointer;

        .send-icon {
          position: relative;
          left: 2px;
        }
      }
    }

    .cross-button {
      position: absolute;

      top: 0.5rem;
      left: 0.5rem;
    }
  }
`;
